var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "system-config" },
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "微信支付配置" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.payment,
                    rules: _vm.paymentRules,
                    size: "medium",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "appId", prop: "appId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入 appId", clearable: "" },
                        model: {
                          value: _vm.payment.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.payment, "appId", $$v)
                          },
                          expression: "payment.appId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户号", prop: "mchId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入微信商户号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.payment.mchId,
                          callback: function ($$v) {
                            _vm.$set(_vm.payment, "mchId", $$v)
                          },
                          expression: "payment.mchId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付密钥", prop: "apiV3Key" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入支付密钥", clearable: "" },
                        model: {
                          value: _vm.payment.apiV3Key,
                          callback: function ($$v) {
                            _vm.$set(_vm.payment, "apiV3Key", $$v)
                          },
                          expression: "payment.apiV3Key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }